const nameInfoTooltip =
  "A name can contain letters, spaces, apostrophes, and hyphens. Letters can have accents, umlauts, etc.";
const userNameInfoToppTip =
  "The format of the user name: <Tenant prefix>_<Org prefix>_<4 chars of family name><3 chars of given name>";
const twoFAInfoToolTip = "2FA option is not available as the user is not active.";
const telephoneInfoTip =
  "The telephone number must conform to the international standards. Accepted formats are 18005551234, (800)5551234, 8005551234, +1 800 555 1234, +18005551234, 0018005551234, 18005551234, 1-800-555-1234 or 18005551234. Max length allowed 20.";
const utcTimeZoneTip = "This timestamp is in Coordinated Universal Time (UTC)";
export { nameInfoTooltip, telephoneInfoTip, userNameInfoToppTip, twoFAInfoToolTip, utcTimeZoneTip };
